import EfSpec from '@elem/ui/ef-spec';
import EfImg from '@elem/ui/ef-img';
import { useMemo } from 'react';
import EfLink from '@elem/ui/ef-link';
import { useRouter } from 'next/router';
import { LearnMoreList } from '../../common';
import { C_DATA } from './common';
import css from './index.module.scss';

export default function C() {
    const { locale = 'us' } = useRouter();
    const { moduleTitle, appTitle, appDesc, otherTitle, otherDesc } = (C_DATA[locale] || C_DATA['us']) ?? {};

    const appUrl = useMemo(() => {
        switch (locale) {
            case 'de':
                return 'https://websiteoss.ecoflow.com/upload/image/1732527713335/DE.png';
            case 'fr':
                return 'https://websiteoss.ecoflow.com/upload/image/1732527713891/FR.png';
            case 'jp':
                return 'https://websiteoss.ecoflow.com/upload/image/1732527714191/JP.png';
            case 'cn':
                return 'https://websiteoss.ecoflow.com/upload/image/1732527713137/CN.png';
            default:
                return 'https://websiteoss.ecoflow.com/upload/image/1732527713500/EN.png';
        }
    }, [locale]);

    return (
        <div className={`support-module ${css['Support']}`}>
            <EfSpec />
            <div className="support-title">{moduleTitle}</div>
            <div className="C-content">
                <div className="C-content-item">
                    <div className="C-title">{appTitle}</div>
                    <div className="C-desc">{appDesc}</div>
                    {['us', 'jp', 'au', 'ca', 'eu', 'uk', 'cn', 'fr', 'de', 'za', 'cis', 'br', 'mx', 'tw'].includes(locale) && (
                        <EfLink
                            className="C-more support-link"
                            href={['tw'].includes(locale) ? 'support/download/index' : 'app'}
                            dataLayer={[
                                {
                                    event: 'uaEvent',
                                    event_name: 'view_more',
                                    list_name: moduleTitle,
                                    button_name: `${appTitle}_${LearnMoreList[locale]}`,
                                },
                            ]}
                        >{`${LearnMoreList[locale]} >`}</EfLink>
                    )}
                    <EfImg className="C-img" pc={appUrl} />
                </div>
                <div className="C-content-item">
                    <div className="C-title">{otherTitle}</div>
                    <div className="C-desc">{otherDesc}</div>
                    <EfLink
                        className="C-more support-link"
                        href="support/download/index"
                        dataLayer={[
                            {
                                event: 'uaEvent',
                                event_name: 'view_more',
                                list_name: moduleTitle,
                                button_name: `${otherTitle}_${LearnMoreList[locale]}`,
                            },
                        ]}
                    >{`${LearnMoreList[locale]} >`}</EfLink>
                    <EfImg className="C-img" pc="https://websiteoss.ecoflow.com/upload/image/1732527713737/file.png" />
                </div>
            </div>
        </div>
    );
}
